import { getData } from "../apiClient";

const API_URL = "hr-dashboard";

/**
 * Get all HR Dashboard data (stats, awards, interviews, trends)
 */
export const GetDashboardData = async (signal = null) => {
    try {
        const result = await getData(`/${API_URL}/list`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error("Get HR Dashboard Data API error:", error);
        return {
            success: false,
            error: error.message
        };
    }
};
